<template>
  <div class="marketing-h5-page">
    <section class="w-full relative z-1">
      <img :src="bannerbgUrl" alt="bannerbg" class="object-contain ease-out w-full h-auto cursor-pointer">

      <div class="px-4 py-3 flex items-center justify-between w-full absolute top-0 left-0 right-0 mx-auto">
        <img :src="logoUrl" alt="Logo"
          class="object-contain transition-all duration-500 ease-out w-[93px] lg:w-auto md:mt-[14px] cursor-pointer">
        <img :src="marketingIconUrl" alt="Logo"
          class="object-contain transition-all duration-500 ease-out w-[208px] lg:w-auto md:mt-[14px] cursor-pointer">
      </div>

      <div class="absolute top-[83px] left-0 right-0 flex flex-col items-center justify-center">
        <img :src="bgTextUrl" alt="bgText" class="object-contain mx-auto cursor-pointer w-[265px]">
        <div class="text-[#123784] text-[16px] font-bold text-center h-[23px]">
          抢占 XR 新风口，共赢数字新未来
        </div>
        <div class="text-[#ffffff] text-[14px] text-center bg-[#2052BC] px-1 py-px rounded-full mt-3">
          沉浸式体验 | 全场景落地 | 低门槛加盟 | 高回报可期
        </div>
      </div>

      <div class="absolute bottom-[34px] left-0 right-0 flex flex-col items-center justify-center">
        <div class="text-[#1F46C5] text-[20px] font-bold text-center h-[29px] stroke-text">
          免加盟费 | 解锁加盟福利
        </div>
      </div>
    </section>

    <section class="w-full -mt-[14px] z-10 relative">
      <div class="flex items-center justify-center px-4">
        <div class="grid w-full max-w-[360px] md:max-w-[540px] grid-cols-3 gap-[17px] overflow-hidden">
          <div
            class="px-[6px] py-[5px] text-left rounded-[16px] backdrop-blur-md card-bg">
            <div class="text-white font-bold mb-[6px] text-[24px]">10+</div>
            <div class="text-[#4580FF] text-[11px] leading-[1.5] md:text-[13px]">
              项核心知识产权<br>
              自主研发多套核心系统
            </div>
          </div>
          <div
            class="px-[6px] py-[5px] text-left rounded-[16px] backdrop-blur-md card-bg">
            <div class="text-white font-bold mb-[6px] text-[24px]">30+</div>
            <div class="text-[#4580FF] text-[11px] leading-[1.5] md:text-[13px]">
              XR大空间业态<br>
              落地30多个城市
            </div>
          </div>
          <div
            class="px-[6px] py-[5px] text-left rounded-[16px] backdrop-blur-md card-bg">
            <div class="text-white font-bold mb-[6px] text-[24px]">10年</div>
            <div class="text-[#4580FF] text-[11px] leading-[1.5] md:text-[13px]">
              核心团队技术骨干<br>
              深耕空间文娱领域超10年
            </div>
          </div>
        </div>
      </div>
      <img :src="jiantouUrl" alt="jiantou"
        class="object-contain ease-out w-[77px] h-auto cursor-pointer my-[10px] mx-auto">
    </section>
    <section class="w-full">
      <img :src="hexinUrl" alt="hexin" class="object-contain ease-out w-full h-auto cursor-pointer px-[51px]">
      <img :src="neirongUrl" alt="neirong"
        class="object-contain ease-out w-full h-auto cursor-pointer px-[16px] pt-[18px]">
    </section>
    <section class="w-full px-[16px] mt-[20px]">
      <img :src="zhinengblUrl" alt="zhinengbl" class="object-contain ease-out w-full h-auto cursor-pointer">
    </section>
    <section class="w-full px-[16px] mt-[20px]">
      <img :src="youshiUrl" alt="youshi" class="object-contain ease-out w-full h-auto cursor-pointer">
    </section>
    <section class="w-full px-[16px] mt-[24px]">
      <img :src="markting_changjingUrl" alt="markting_changjing"
        class="object-contain ease-out w-full h-auto cursor-pointer px-[51px]">
      <img :src="photoUrl" alt="market_photo.webp"
        class="object-contain ease-out w-full h-auto cursor-pointer mt-[31px]">
      <div class="w-full mt-[24px] grid grid-cols-3 items-center justify-center gap-[16px]">
        <img :src="marketing_3Url" alt="marketing_3" class="object-contain ease-out w-full h-auto cursor-pointer">
        <img :src="marketing_2Url" alt="marketing_2" class="object-contain ease-out w-full h-auto cursor-pointer">
        <img :src="marketing_1Url" alt="marketing_1" class="object-contain ease-out w-full h-auto cursor-pointer">
      </div>
    </section>
    <section class="w-full px-[16px] mt-[44px]">
      <img :src="rujuUrl" alt="ruju" class="object-contain ease-out w-full h-auto cursor-pointer px-[51px]">
    </section>
    <section class="w-full px-[16px] mt-[44px]">
      <div class="w-full  mx-auto">
        <!-- 外层渐变卡片 -->
        <div class="rounded-[16px] p-px"
          style="background: linear-gradient(180deg, #FFF 0%, rgba(255, 255, 255, 0) 100%);">
          <!-- 内层卡片 -->
          <div class="rounded-[16px] px-[10px] py-5"
            style="background: linear-gradient(165deg, rgba(0, 190, 184, 0.5) 0%, rgba(152, 2, 183, 0.5) 100%);">
            <form class="space-y-3">
              <!-- 姓名 -->
              <div class="rounded-[4px] px-[10px] py-[8px] input-wrapper" style="background: rgba(55, 55, 55, 0.2);">
                <input v-model="form.name" type="text" placeholder="*请输入您的姓名"
                  class="w-full bg-transparent outline-none border-none text-white text-[14px] placeholder:text-white/80 h-[44px]" />
              </div>
              <!-- 电话 -->
              <div class="rounded-[4px] px-[10px] py-[8px] input-wrapper" style="background: rgba(55, 55, 55, 0.2);">
                <input v-model="form.phone" type="tel" placeholder="*请输入您的电话"
                  class="w-full bg-transparent outline-none border-none text-white text-[14px] placeholder:text-white/80 h-[44px]" />
              </div>
              <!-- 按钮 -->
              <div class="w-full flex items-center justify-center mt-[16px] px-[90px]" @click="handleSubmit">
                <img :src="marketing_4Url" alt="marketing_4"
                  class="object-contain ease-out w-full h-auto cursor-pointer">
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <section class="w-full px-[26px] mt-[26px]">
      <div class="text-[#333333] text-[14px] text-left">
        <div class="font-bold">总部承诺：</div>
        信息严格保密，24小时内专人对接，全程免费咨询
        欢迎您的咨询与加入。
      </div>
    </section>
    <section class="w-full px-[47px] mt-[24px]">
      <img :src="marketingIconUrl" alt="photo" class="object-contain ease-out w-full h-auto cursor-pointer">
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { contactApi } from "@/api";
import { RequestError } from "@/utils/request";
import logo from "@/assets/img/logo.webp";
import marketing_icon from "@/assets/img/marketing_icon.png";
import bannerbg from "@/assets/img/bannerbg.webp";
import bgText from "@/assets/img/bgText.webp";
import neirong from "@/assets/img/neirong.webp";
import zhinengbl from "@/assets/img/zhinengbl.webp";
import youshi from "@/assets/img/youshi.webp";
import photo from "@/assets/img/market_photo.webp";
import jiantou from "@/assets/img/jiantou.webp";
import hexin from "@/assets/img/hexin.webp";
import ruju from "@/assets/img/ruju.webp";
import markting_changjing from "@/assets/img/markting_changjing.webp";
import marketing_1 from "@/assets/img/marketing_1.webp";
import marketing_2 from "@/assets/img/marketing_2.webp";
import marketing_3 from "@/assets/img/marketing_3.webp";
import marketing_4 from "@/assets/img/marketing_4.webp";


const logoUrl = logo;
const marketingIconUrl = marketing_icon;
const bannerbgUrl = bannerbg;
const bgTextUrl = bgText;
const neirongUrl = neirong;
const zhinengblUrl = zhinengbl;
const youshiUrl = youshi;
const photoUrl = photo;
const jiantouUrl = jiantou;
const hexinUrl = hexin;
const rujuUrl = ruju;
const markting_changjingUrl = markting_changjing;
const marketing_1Url = marketing_1;
const marketing_2Url = marketing_2;
const marketing_3Url = marketing_3;
const marketing_4Url = marketing_4;
const form = ref({
  name: "",
  phone: "",
});

const submitting = ref(false);

const handleSubmit = async () => {
  if (submitting.value) return;

  const name = form.value.name.trim();
  const phone = form.value.phone.trim();

  if (!name || !phone) {
    alert("请输入姓名和电话");
    return;
  }

  // 简单电话格式校验（支持手机号或座机号）
  const phoneRegex = /^(1[3-9]\d{9}|0\d{2,3}-?\d{7,8})$/;
  if (!phoneRegex.test(phone)) {
    alert("请输入有效的电话号码（手机号或座机号）");
    return;
  }

  submitting.value = true;
  try {
    const res = await contactApi.submitJoinForms({
      investmentBudget: "",
      storeLocation: "",
      storeArea: "",
      city: "",
      contactName: name,
      contactPhone: phone,
      inquiryContent: "",
    });

    if (res.code === 200 || res.success) {
      alert("申请已提交，请等待客服与您沟通");
      form.value = { name: "", phone: "" };
    } else {
      alert(res.message || "提交失败，请稍后重试");
    }
  } catch (error) {
    console.error("提交表单失败:", error);
    if (error instanceof RequestError) {
      alert(error.message || "提交失败，请稍后重试");
    } else {
      alert("提交失败，请稍后重试");
    }
  } finally {
    submitting.value = false;
  }
};
</script>

<style scoped>
.marketing-h5-page {
  min-height: 100vh;
  background: #D0ECFF;
  padding-bottom: 51px;
}

.stroke-text {
  /* 使用多重 text-shadow 模拟 1px 描边，更自然柔和 */
  text-shadow:
    -1px 0 0 #FFF683,
    1px 0 0 #FFF683,
    0 -1px 0 #FFF683,
    0 1px 0 #FFF683;
}

.input-wrapper {
  position: relative;
}

.input-wrapper::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 0;
  width: 2px;
  bottom: 2px;
  background: linear-gradient(180deg, #4a90e2, #4a90e2);
  pointer-events: none;
  border-radius: 2rem;
}

.input-wrapper::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #4a90e2, #f161f9);
  opacity: 1;
  pointer-events: none;
  border-radius: 0 0 2rem 2rem;
}

.card-bg {
  background: linear-gradient(180deg,rgba(214, 244, 255, 0.17),#9FE5FF 100%);
}
</style>
